import { Info } from "lucide-react";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { TDM_CATEGORIES, TDM_SECTORS } from "@/lib/tdm-constants";

// Resumen no técnico de qué considera cada categoría.
const CATEGORY_HINT: Record<string, string> = {
  LIQUIDO: "Asfaltos diluidos (los de grado RC o MC, como RC-250 o MC-30).",
  SOLIDO: "El resto: asfalto en caliente, en frío, cemento asfáltico, etc.",
  EMULSION: "Asfaltos en emulsión (los que dicen “emulsión”).",
};

// Regiones incluidas en cada sector (para mostrar al usuario).
const SECTOR_REGIONS: Record<string, string> = {
  NORTE:
    "Tumbes, Piura, Lambayeque, La Libertad, Cajamarca, Amazonas, San Martín y Loreto.",
  CENTRO:
    "Áncash, Huánuco, Pasco, Junín, Lima, Callao, Ica, Huancavelica, Ayacucho y Ucayali.",
  SUR: "Arequipa, Moquegua, Tacna, Cusco, Puno, Apurímac y Madre de Dios.",
};

export function TdmInfoButton() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className="flex items-center gap-1.5 rounded-full border bg-card px-3 py-1.5 text-xs font-semibold text-muted-foreground shadow-sm transition-colors hover:bg-accent"
          aria-label="Información sobre categorías y sectores"
        >
          <Info className="size-4" />
          Info
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 space-y-4">
        <div className="space-y-2">
          <p className="text-xs font-bold uppercase tracking-wide text-muted-foreground">
            Categorías
          </p>
          {TDM_CATEGORIES.map((c) => (
            <div key={c.key} className="flex gap-2">
              <span
                className="mt-1 size-2.5 shrink-0 rounded-full"
                style={{ backgroundColor: c.color }}
              />
              <p className="text-sm">
                <span className="font-semibold">{c.label}:</span>{" "}
                <span className="text-muted-foreground">
                  {CATEGORY_HINT[c.key]}
                </span>
              </p>
            </div>
          ))}
        </div>

        <div className="space-y-2 border-t pt-3">
          <p className="text-xs font-bold uppercase tracking-wide text-muted-foreground">
            Sectores
          </p>
          {TDM_SECTORS.map((s) => (
            <div key={s.key} className="flex gap-2">
              <span
                className="mt-1 size-2.5 shrink-0 rounded-full"
                style={{ backgroundColor: s.color }}
              />
              <p className="text-sm">
                <span className="font-semibold">{s.label}:</span>{" "}
                <span className="text-muted-foreground">
                  {SECTOR_REGIONS[s.key]}
                </span>
              </p>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
